import { Container, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system'
import { useTheme } from '@emotion/react';
import JobList from './job/JobList';
import { useEffect } from 'react';
import { useState } from 'react';
import useAxiosPrivate from '../hooks/use-axios-private';
import Skeleton from '@mui/material/Skeleton';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import RotateRightOutlinedIcon from '@mui/icons-material/RotateRightOutlined';
import AutoModeOutlinedIcon from '@mui/icons-material/AutoModeOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

const Homepage = () => {
    const theme = useTheme();
    const [dashboard, setDashboard] = useState({ total_jobs: false, pending: false, in_progress: false, completed: false })
    const axios = useAxiosPrivate()
    async function getDashboardMetrics() {
        try {
            const response = await axios.get("dashboard/")
            setDashboard(response.data.data.jobs_count)
        }
        catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        getDashboardMetrics()
    }, [])

    return (
        <Container maxWidth="xl">
            <Box sx={{ mb: 2, mt: 3 }}>
                <Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Dashboard</Typography>
            </Box>
            <Box sx={{ flexGrow: 1, mt: 3 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ p: 3, borderRadius: 2, backgroundColor: theme.palette.mode === "dark" ? 'background.card' : 'background.card', color: "text.title", boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>

                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box>
                                    <Typography sx={{ textTransform: 'capitalize', fontSize: { xs: 16, xl: 18 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Orders</Typography>
                                </Box>
                                <Box sx={{ background: "#fee3ee", width: "43px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%" }}>
                                    <InventoryOutlinedIcon sx={{ color: "#f764a3" }} />
                                </Box>
                            </Box>

                            {dashboard.total_jobs === false ?
                                <Box>
                                    <Skeleton variant="rounded" width={26} height={26} sx={{ mt: 2 }} animation="wave" />
                                </Box> :
                                <Typography sx={{ mt: 2, fontWeight: 500, fontSize: { xs: 22, xl: 24 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }} variant='h4'>{dashboard.total_jobs}</Typography>
                            }

                            {/* <Box sx={{ mt: 2 }}>
                                <Typography sx={{ color: "#07ad94", fontWeight: 500, fontSize: "14px" }} variant='span'>1500</Typography>
                                <Typography sx={{ fontSize: "14px", ml: 1, color: "#818181" }} variant='span'>Orders up from yesterday</Typography>
                            </Box> */}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ p: 3, borderRadius: 2, backgroundColor: theme.palette.mode === "dark" ? 'background.card' : 'background.card', color: "text.title", boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box>
                                    <Typography sx={{ textTransform: 'capitalize', fontSize: { xs: 16, xl: 18 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Pending</Typography>
                                </Box>
                                <Box sx={{ background: "#ffeed9", width: "43px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%" }}>
                                    <RotateRightOutlinedIcon sx={{ color: "#fd905e", fontSize: "30px" }} />
                                </Box>
                            </Box>
                            {
                                dashboard.pending === false ?
                                    <Box>
                                        <Skeleton variant="rounded" width={26} height={26} sx={{ mt: 2 }} animation="wave" />
                                    </Box> :
                                    <Typography sx={{ mt: 2, fontWeight: 500, fontSize: { xs: 22, xl: 24 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }} variant='h4'>{dashboard.pending}</Typography>
                            }
                            {/* <Box sx={{ mt: 2 }}>
                                <Typography sx={{ color: "#07ad94", fontWeight: 500, fontSize: "14px" }} variant='span'>1500</Typography>
                                <Typography sx={{ fontSize: "14px", ml: 1, color: "#818181" }} variant='span'>Orders up from yesterday</Typography>
                            </Box> */}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ p: 3, borderRadius: 2, backgroundColor: theme.palette.mode === "dark" ? 'background.card' : 'background.card', color: "text.title", boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box>
                                    <Typography sx={{ textTransform: 'capitalize', fontSize: { xs: 16, xl: 18 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>In Progress</Typography>
                                </Box>
                                <Box sx={{ background: "#efedfe", width: "43px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%" }}>
                                    <AutoModeOutlinedIcon sx={{ color: "#0b1345" }} />
                                </Box>
                            </Box>
                            {
                                dashboard.in_progress === false ?
                                    <Box>
                                        <Skeleton variant="rounded" width={26} height={26} sx={{ mt: 2 }} animation="wave" />
                                    </Box> :
                                    <Typography sx={{ mt: 2, fontWeight: 500, fontSize: { xs: 22, xl: 24 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }} variant='h4'>{dashboard.in_progress}</Typography>
                            }
                            {/* <Box sx={{ mt: 2 }}>
                                <Typography sx={{ color: "#07ad94", fontWeight: 500, fontSize: "14px" }} variant='span'>1500</Typography>
                                <Typography sx={{ fontSize: "14px", ml: 1, color: "#818181" }} variant='span'>Orders up from yesterday</Typography>
                            </Box> */}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ p: 3, borderRadius: 2, backgroundColor: theme.palette.mode === "dark" ? 'background.card' : 'background.card', color: "text.title", boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box>
                                    <Typography sx={{ textTransform: 'capitalize', fontSize: { xs: 16, xl: 18 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Completed</Typography>
                                </Box>
                                <Box sx={{ background: "#d7f6e6", width: "43px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%" }}>
                                    <TaskAltOutlinedIcon sx={{ color: "#66dca2" }} />
                                </Box>
                            </Box>
                            {
                                dashboard.completed === false ?
                                    <Box>
                                        <Skeleton variant="rounded" width={26} height={26} sx={{ mt: 2 }} animation="wave" />
                                    </Box> :
                                    <Typography sx={{ mt: 2, fontWeight: 500, fontSize: { xs: 22, xl: 24 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }} variant='h4'>{dashboard.completed}</Typography>
                            }
                            {/* <Box sx={{ mt: 2 }}>
                                <Typography sx={{ color: "#07ad94", fontWeight: 500, fontSize: "14px" }} variant='span'>1500</Typography>
                                <Typography sx={{ fontSize: "14px", ml: 1, color: "#818181" }} variant='span'>Orders up from yesterday</Typography>
                            </Box> */}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ mt: 4 }} >
                <JobList onChange={getDashboardMetrics} />
            </Box>
        </Container>
    )
}

export default Homepage